
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pickleball/region/[regionSlug]",
      function () {
        return require("private-next-pages/pickleball/region/[regionSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pickleball/region/[regionSlug]"])
      });
    }
  